import React, { Component, PropTypes } from 'react';
import { Styles, FontIcon } from 'material-ui';
import MenuItem from 'components/Material/MenuItem';
import * as Icons from 'components/Material/SvgIcons';
import * as Colors from 'components/Material/Styles/Colors';

let { Spacing } = Styles;

const styles = {
  icon: {
    display: 'inline-block',
    verticalAlign: 'middle',
    margin: `0 ${Spacing.desktopGutterMini}px`
  }
};

export default class CollapsibleMenu extends Component {
  state = {
    expanded: this.props.initialExpanded
  };

  static propTypes = {
    padding: PropTypes.number,
    style: PropTypes.object,
    menuStyle: PropTypes.object,
    initialExpanded: PropTypes.bool,
    onItemTap: PropTypes.func
  };

  static defaultProps = {
    padding: Spacing.desktopGutterMini,
    style: {},
    menuStyle: {},
    initialExpanded: true
  };

  toggle() {
    this.setState({ expanded: !this.state.expanded });
  }

  getMenuStyle() {
    return Object.assign({}, this.props.menuStyle);
  }

  getStyle() {
    return Object.assign({}, this.props.menuStyle);
  }

  getItemStyle() {
    return Object.assign(
      {
        paddingLeft: Spacing.desktopGutterMini * 2
      },
      this.props.menuItemStyle
    );
  }

  _onItemTap(menuItem, e) {
    if (this.props.onItemTap) {
      this.props.onItemTap(menuItem, e);
    }
  }

  render() {
    let { padding, style, menuItems, menuStyle, header, ...other } = this.props;
    let menuElement,
      rightIcon,
      menuElements = menuItems.map((menuItem, index) => {
        let leftIcon;
        if (menuItem.icon) {
          leftIcon = (
            <menuItem.icon
              style={styles.icon}
              color={Colors.Colors.fullWhite}
            />
          );
        } else {
          leftIcon = (
            <FontIcon
              color={Colors.Colors.fullWhite}
              className={menuItem.iconClassName}
            />
          );
        }
        return (
          <MenuItem
            count={menuItem.count}
            style={this.getItemStyle()}
            onTouchTap={this._onItemTap.bind(this, menuItem)}
            primaryText={menuItem.text}
            index={index}
            key={index}
            leftIcon={leftIcon}
          />
        );
      });
    if (this.state.expanded) {
      // rightIcon = <Icons.HardwareKeyboardArrowUp />
      menuElement = (
        <div style={this.getMenuStyle()} {...other}>
          {menuElements}
        </div>
      );
    } else {
      // rightIcon = <Icons.HardwareKeyboardArrowDown />
    }
    let icon;
    if (this.props.icon) {
      let Icon = this.props.icon;
      icon = <Icon style={styles.icon} color={Colors.Colors.fullWhite} />;
    } else {
      icon = (
        <FontIcon
          color={this.props.iconColor}
          className={this.props.iconClassName}
        />
      );
    }
    return (
      <div>
        <MenuItem
          style={this.props.menuItemStyle}
          leftIcon={icon}
          onTouchTap={this.toggle.bind(this)}
          primaryText={header}
          rightIcon={rightIcon}
        />
        {menuElement}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Material/CollapsibleMenu.js